<template>
  <div class="txt has-txt-scroll" ref="warpRef">
    <div class="in" ref="inRef" v-if="data.length">
      <vue-seamless-scroll
        :data="data"
        :class-option="classOption"
        class="scroll-box"
      >
        <div v-for="(item, idx) in data" :key="idx" class="red dd">
          <i class="iconfont icon-f-o"></i>
          <div class="cell">
            <span class="b">{{ item.objectId }}</span>
            <span>
              {{
                item.estartInsufficient
                  ? dayjs(item.estartInsufficient).format('MM/DD HH:mm')
                  : ''
              }}
            </span>
          </div>
        </div>
      </vue-seamless-scroll>
    </div>
    <div class="dd" v-else>
      <i class="iconfont icon-f-o"></i>
      <div class="cell">-</div>
    </div>
  </div>
</template>

<script>
  import vueSeamlessScroll from 'vue-seamless-scroll/src'
  import dayjs from 'dayjs'
  export default {
    components: {
      vueSeamlessScroll,
    },
    props: {
      data: {
        type: Array,
        default() {
          return []
        },
      },
      waitTime: {
        type: Number,
        default: 1000,
      },
    },
    data() {
      return {
        boxHeight: 90,
      }
    },
    mounted() {
      this.boxHeight = this.$refs.warpRef ? this.$refs.warpRef.clientHeight : 90
      window.addEventListener('resize', () => {
        this.boxHeight = this.$refs.warpRef
          ? this.$refs.warpRef.clientHeight
          : 90
      })
    },
    unmounted() {},
    computed: {
      classOption() {
        return {
          singleHeight: this.boxHeight,
          waitTime: this.waitTime,
          limitMoveNum: 2,
          direction: 1,
        }
      },
    },
    methods: {
      dayjs,
    },
  }
</script>

<style lang="less" scoped>
  @import '~@/styles/variables.less';
  .has-txt-scroll {
    position: relative;
    height: 100%;
    overflow: hidden;
    :deep(.in) {
      display: block;
      height: 100%;
      overflow: hidden;
    }

    &.txt {
      height: 100%;
      width: 100%;
      margin: 0;
      display: flex;
      align-items: center;
    }
    :deep(.dd) {
      font-size: 12px;
      position: relative;
      height: 90px;
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #ddd;
      & > i {
        width: 30%;
        font-size: 32px;
        font-weight: normal;
        text-align: right;
      }
      & > .cell {
        flex: 1;
        padding-left: 10px;
        text-align: left;
        font-size: 14px;
        display: flex;
        flex-direction: column;
        > span {
          line-height: 1;
        }
      }
      &.red {
        color: @danger;
      }
      .b {
        font-size: 18px;
        font-weight: 600;
        display: block;
      }
    }
  }
</style>
